import React, { useEffect, useState } from "react";
import AddUserPopup from "../Component/AddUserPopup";
import { API_BASE_URL } from "../config";

export default function Users() {
  const [users, setUsers] = useState([]);
  const [newUser, setNewUser] = useState({ courtName: "", location: "" });

  useEffect(() => {
    // Fetch users from API    
    fetchUsers();
  }, []);
const fetchUsers = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await fetch(`${API_BASE_URL}/api/User/getuser`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.ok) {
          const data = await res.json();
          setUsers(data);
        } else {
          console.error("Failed to fetch users");
        }
      } catch (err) {
        console.error("Error:", err);
      }
    };

// Add new User
  const handleAddUser = async (newUser) => {
    // e.preventDefault();
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE_URL}/api/User/adduser`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(newUser),
      });
      if (res.ok) {
        fetchUsers(); // Refresh list
        setNewUser({ courtName: "", location: "" });
        alert("User added successfully!");
      } else {
        console.error("Failed to add User");
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };
  
const handleRoleChange = async (id, newRole) => {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE_URL}/api/User/update-role/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(newRole),
      });

      if (res.ok) {
        // Update role in local state (without refetching full list)
        setUsers((prev) =>
          prev.map((u) => (u.id === id ? { ...u, role: newRole } : u))
        );
        alert("Role updated successfully!");
      } else {
        console.error("Failed to update role");
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };



  return (
    <div style={{ padding: "20px" }}>
      <h2>Manage Users</h2>
      <AddUserPopup onAddUser={handleAddUser} />
      <table border="1" cellPadding="10" style={{ width: "100%", marginTop: "20px" }}>
        <thead style={{ background: "#f4f4f4" }}>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Phon No</th>
            <th>Role</th>
            <th>Updare Role</th>
          </tr>
        </thead>
        <tbody>
          {users.length > 0 ? (
            users.map((user) => (
              <tr key={user.id}>                
                <td>{user.fullName}</td>
                <td>{user.email}</td>
                <td>{user.phoneNumber}</td>
                <td>{user.role}</td>
                 <td>
                  <select
                    value={user.role}
                    onChange={(e) => handleRoleChange(user.id, e.target.value)}
                  >
                    <option value="User">User</option>
                    <option value="Admin">Admin</option>
                  </select>
                  </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4">No users found</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
